export default __webpack_public_path__ + "static/media/misc-books4.d810e8c4.jpg";